import React, {useContext, useState} from 'react'
import { useEffect } from 'react'
import { v4 as uuidv4 } from 'uuid'
import { ExchangeItem } from '../OrderContext/types'
import http from '../http'
import { OrderContext } from "../OrderContext";
import { chain } from "lodash";

type ExchangeItemContextState = {
    showSearch: boolean
    setShowSearch: React.Dispatch<boolean>,
    exchangeItems: ExchangeItem[],
    loading: boolean,
    error: boolean
}

export const ExchangeItemContext = React.createContext<ExchangeItemContextState>({} as ExchangeItemContextState)

export const ExchangeItemContextProvider: React.FC = (props) => {
    const {order} = useContext(OrderContext)
    const [showSearch, setShowSearch] = useState<boolean>(false)
    const [exchangeItems, setExchangeItems] = useState<ExchangeItem[]>([])
    const [loading, setLoading] = useState<boolean>(false)
    const [error, setError] = useState<boolean>(false)

    useEffect(() => {
        setExchangeItems([])
        setLoading(true)
        setError(false)

        http.get<ExchangeItem[]>(`/api/Catalog?productIds=${encodeURIComponent(chain(order).map(mb => mb.material).join(',').value())}`)
            .then(({ data }) => setExchangeItems(data.filter(d => d.productId)
                .map(d => ({ ...d, id: uuidv4(), productId: d.productId as string }))))
            .catch(() => setError(true))
            .finally(() => setLoading(false))
    }, [order])

    return <ExchangeItemContext.Provider {...props} value={{
        showSearch,
        setShowSearch,
        exchangeItems,
        loading,
        error
    }} />
}
